export default {
  bookshelf: {
    visible: ['oversight', 'survey'],
    component: () => import('./TileBookshelf.vue'),
    options: () => import('./options/TileBookshelfOptions.vue'),
  },
  likert_score: {
    visible: ['oversight'],
    component: () => import('./TileLikertScore.vue'),
    options: () => import('./options/TileLikertScoreOptions.vue'),
  },
  multiple_choice_frequency: {
    visible: ['oversight'],
    component: () => import('./TileMultipleChoiceFrequency.vue'),
    options: () => import('./options/TileMultipleChoiceFrequencyOptions.vue'),
  },
  notifications: {
    visible: ['oversight', 'serviceprovider'],
    component: () => import('./TileNotifications.vue'),
    options: () => import('./options/TileNotificationsOptions.vue'),
  },
  submission_status: {
    visible: ['oversight'],
    component: () => import('./TileSubmissionStatus.vue'),
    options: () => import('./options/TileSubmissionStatusOptions.vue'),
  },
  survey_progress: {
    visible: ['survey'],
    component: () => import('./TileSurveyProgress.vue'),
    options: () => import('./options/TileSurveyProgressOptions.vue'),
  },
};
